var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgFlag(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 31 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M7.293 1.125v1.313l3.984-.985c1.782-.422 3.657-.234 5.297.61a7.744 7.744 0 006.89 0l.47-.235c.937-.469 2.109.234 2.109 1.313v13.078c0 .656-.422 1.172-.984 1.406l-1.641.61c-2.156.843-4.547.703-6.656-.329a8.338 8.338 0 00-5.719-.656l-3.75.938v4.687A1.11 1.11 0 016.168 24c-.656 0-1.125-.469-1.125-1.125V1.125C5.043.515 5.512 0 6.168 0c.61 0 1.125.516 1.125 1.125zm0 3.656v11.11l3.187-.797a10.666 10.666 0 017.313.797c1.5.75 3.234.843 4.828.234l1.172-.422V4.36c-2.672 1.079-5.672.985-8.203-.28a5.34 5.34 0 00-3.797-.423l-4.5 1.125z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgFlag);
export default ForwardRef;
